import { FormikHelpers } from "formik";
import { useGetDCompany } from "./api/getDCompany";
import { useEditDCompany } from "./api/editDCompany";
import EditDCompanyForm from "./EditDCompanyForm";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditDCompany = ({handleCloseModal, dCompanyId}: EditDCompanyProps)  => {
  const getDCompanyQuery = useGetDCompany({dCompanyId: dCompanyId})
  const editDCompanyMutation = useEditDCompany({data: {}, dCompanyId});

  const initialValues: IEditDCompanyForm = {
    description: getDCompanyQuery.data?.description ? getDCompanyQuery.data?.description : "",
    placeID: getDCompanyQuery.data ? getDCompanyQuery.data.placeID.toString() : "",
    modemID: getDCompanyQuery.data ? getDCompanyQuery.data.modemID.toString() : "",
    modemPort: getDCompanyQuery.data?.modemPort ? getDCompanyQuery.data?.modemPort : "",
    unID: getDCompanyQuery.data?.unID ? getDCompanyQuery.data?.unID : "",
    sapCode: getDCompanyQuery.data?.sapCode ? getDCompanyQuery.data?.sapCode : "",
    isEmporiki: getDCompanyQuery.data?.isEmporiki ? getDCompanyQuery.data?.isEmporiki : false,
    isCiti: getDCompanyQuery.data?.isCiti ? getDCompanyQuery.data?.isCiti : false,
    filepath: getDCompanyQuery.data?.filepath ? getDCompanyQuery.data?.filepath : "",
    hubType: getDCompanyQuery.data?.hubType ? getDCompanyQuery.data?.hubType : "",
    anetVoice: getDCompanyQuery.data?.anetVoice ? getDCompanyQuery.data?.anetVoice : "",
    comments: getDCompanyQuery.data?.comments ? getDCompanyQuery.data?.comments : "",
    deleted: getDCompanyQuery.data?.deleted ? getDCompanyQuery.data?.deleted : false,
    fallsUnder: getDCompanyQuery.data?.fallsUnder ? getDCompanyQuery.data?.fallsUnder.toString() : ""
  };

  const handleSubmit = async (values: IEditDCompanyForm, { setSubmitting }: FormikHelpers<IEditDCompanyForm>): Promise<void> => {
    try {
      await editDCompanyMutation.mutateAsync({
        data: values,
        dCompanyId: dCompanyId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getDCompanyQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getDCompanyQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Θυγατρικής.</div>
    )
  }

  return (
    <>
      {!getDCompanyQuery.isLoading && getDCompanyQuery.data &&
        <EditDCompanyForm initialValues={initialValues}  onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditDCompanyProps {
  dCompanyId: number;
  handleCloseModal: () => void;
}

export default EditDCompany;